function safeName(value) {
  return String(value || 'member').trim().replace(/[^a-z0-9-_]+/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') || 'member';
}

function xmlEscape(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

function cell(value) {
  const isNumber = typeof value === 'number' && Number.isFinite(value);
  return `<Cell><Data ss:Type="${isNumber ? 'Number' : 'String'}">${xmlEscape(value ?? '')}</Data></Cell>`;
}

function worksheet(name, rows) {
  const headers = rows.length ? Object.keys(rows[0]) : [];
  const headerXml = headers.length ? `<Row>${headers.map((header) => cell(header)).join('')}</Row>` : '';
  const rowsXml = rows.map((row) => `<Row>${headers.map((header) => cell(row[header])).join('')}</Row>`).join('');
  return `<Worksheet ss:Name="${xmlEscape(name)}"><Table>${headerXml}${rowsXml}</Table></Worksheet>`;
}

export function exportIndividualPerformanceToExcel(data, employee, period) {
  const roleMetricRows = [];
  (data?.roleSections || []).forEach((section) => {
    (section.metricRows || []).forEach((row) => {
      roleMetricRows.push({
        Role: section.label,
        'Milestone Type': row.milestone_type,
        Output: row.output_count,
        'Quality Passed': row.quality_passed ?? '',
        'Quality Error / Failed': row.quality_failed ?? '',
        'Quality Blank': row.quality_blank ?? '',
        'Quality %': row.quality_percent ?? '',
        'TAT Target': row.tat_threshold_label,
        'TAT On-Time': row.tat_on_time,
        'TAT Late': row.tat_late,
        'TAT On-Time %': row.tat_on_time_percent,
      });
    });
  });

  const kpiRows = (data?.kpiSummary || []).map((item) => ({
    Metric: item.label,
    Value: item.format === 'hoursPerDay' && item.value !== null && item.value !== undefined ? `${item.value} h/day` : item.value ?? item.displayValue ?? 'N/A',
    Detail: item.helper || '',
  }));

  const assignmentRows = (data?.assignments || []).map((row) => ({
    Project: row.project_name,
    Date: row.milestone_date,
    'Milestone Type': row.milestone_type,
    'Assigned Role': row.assigned_role,
    'Service Type': row.service_type,
    TAT: row.tat_hours ?? '',
    'Target TAT': row.target_tat_label,
    'Milestone QA Result': row.qa_result,
    'CRE Restamp Reason': row.cre_restamp_reason,
    Status: row.status,
  }));

  const workbook = `<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?>\n` +
    `<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">` +
    worksheet('KPI', kpiRows) + worksheet('Role Metrics', roleMetricRows) + worksheet('Assignments', assignmentRows) + `</Workbook>`;

  const blob = new Blob([workbook], { type: 'application/vnd.ms-excel;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `team-member-detail-${safeName(employee?.name)}-${period?.start}-to-${period?.end}.xls`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
